import React from 'react'
import { Button } from 'shards-react'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import addFont from '../../../../fonts/fonts'
import styles from '../styles.module.css'


const orientation = 'l'
const fileTitle = 'Отчет о работниках (форма №3СВУ)'

const FONT_NAME = 'Montserrat'
const BODY_FONT_SIZE = 8
const HEAD_FONT_SIZE = 8
const VERTICAL_FONT_SIZE = 7
const VERTICAL_HEAD_HEIGHT = 45

const fmt = (v) => (v === null || v === undefined || v === '') ? '—' : v

const GROUPS = [
  { key: 'total',      label: 'Всего работников',               staff: 'totalStaff',      list: 'totalList',      reserve: 'reserveOfficersTotal' },
  { key: 'leadership', label: 'Руководящий состав',             staff: 'leadershipStaff', list: 'leadershipList', reserve: 'reserveOfficersLeadership' },
  { key: 'admin',      label: 'Административный персонал',      staff: 'adminStaff',      list: 'adminList',      reserve: 'reserveOfficersAdmin' },
  { key: 'support',    label: 'Учебно-вспомогательный персонал', staff: 'supportStaff',   list: 'supportList',    reserve: 'reserveOfficersSupport' },
]

const EXPERIENCE = [
  { key: 'lt3',  label: 'До 3 лет',     field: 'experienceLessThan3' },
  { key: 'lt10', label: 'До 10 лет',    field: 'experienceLessThan10' },
  { key: 'lt20', label: 'До 20 лет',    field: 'experienceLessThan20' },
  { key: 'gt20', label: 'Более 20 лет', field: 'experienceGreaterThanOrEq20' },
]

const POSITIONS = [
  { key: 'teachers',       label: 'Преподавателей',                        field: 'teachersCount' },
  { key: 'classTeachers',  label: 'Классных руководителей',                field: 'classTeachersCount' },
  { key: 'psychologists',  label: 'Педагогов-психологов',                  field: 'pedagoguePsychologistsCount' },
  { key: 'organizers',     label: 'Педагогов-организаторов',               field: 'pedagogueOrganizersCount' },
  { key: 'additionalEdu',  label: 'Педагогов дополнительного образования', field: 'pedagoguesAdditionalEducationCount' },
  { key: 'seniorEdu',      label: 'Старших воспитателей',                  field: 'seniorEducatorsCount' },
  { key: 'educators',      label: 'Воспитателей',                          field: 'educatorsCount' },
  { key: 'pe',             label: 'Инструкторов по физической культуре',   field: 'physicalCultureInstructorsCount' },
  { key: 'seniorMethod',   label: 'Старших методистов',                    field: 'seniorMethodistsCount' },
  { key: 'methodists',     label: 'Методистов',                            field: 'methodistsCount' },
]

const CATEGORIES = [
  { key: 'higher',      label: 'Высшая КК',                                      field: 'higherCategoryCount' },
  { key: 'first',       label: 'Первая КК',                                      field: 'firstCategoryCount' },
  { key: 'eligibility', label: 'Аттестованы на соответствие занимаемой должности', field: 'positionEligibilityCount' },
]

const AWARD_CATEGORIES = [
  { key: 'total',       label: 'Всего' },
  { key: 'leadership',  label: 'Руководящий состав' },
  { key: 'admin',       label: 'Административный персонал' },
  { key: 'pedagogical', label: 'Педагогические работники' },
]


const byId = (rows) => Object.fromEntries((rows || []).map(r => [r.organizationId, r]))

const getAwardsList = (row) => {
  const awards = row?.awards
  if (!awards) return []
  return Array.isArray(awards) ? awards : [awards]
}

const v = (content, extra = {}) => ({ content, ...extra, _vertical: true })


export default function Buttons ({ visible, data }) {

  const drawPageHeader = (doc, { tableNumber, tableTitle, organizationName, yearTitle }) => {
    const { width } = doc.internal.pageSize
    const margin = 14
    const sideLabelReserve = 70
    let y = 12

    doc.setFontSize(9)
    doc.setFont(FONT_NAME, 'bold')
    doc.text('Министерство обороны Российской Федерации', width / 2, y, { align: 'center' })
    y += 4
    doc.text('Департамент военного образования', width / 2, y, { align: 'center' })
    doc.setFont(FONT_NAME, 'normal')
    y += 6

    doc.setFontSize(10)
    doc.text('Форма №3/СВУ', width - margin, y, { align: 'right' })

    doc.setFontSize(11)
    const titleLines = doc.splitTextToSize(
      `${tableTitle} ${yearTitle}`,
      width - margin * 2 - sideLabelReserve,
    )
    titleLines.forEach(line => {
      doc.text(line, width / 2, y, { align: 'center' })
      y += 6
    })

    doc.setFontSize(10)
    doc.text(`Таблица №${tableNumber}`, width - margin, y, { align: 'right' })

    if (organizationName) {
      doc.setFontSize(11)
      const orgLines = doc.splitTextToSize(organizationName, width - margin * 2 - sideLabelReserve)
      orgLines.forEach(line => {
        doc.text(line, width / 2, y, { align: 'center' })
        y += 6
      })
    }

    return y + 2
  }

  const verticalHeadHooks = {
    didParseCell: (hookData) => {
      const raw = hookData.cell.raw
      if (hookData.section === 'head' && raw && typeof raw === 'object' && raw._vertical) {
        hookData.cell._verticalContent = String(raw.content ?? '')
        hookData.cell.text = []
        if ((hookData.cell.styles.minCellHeight || 0) < VERTICAL_HEAD_HEIGHT) {
          hookData.cell.styles.minCellHeight = VERTICAL_HEAD_HEIGHT
        }
      }
    },
    didDrawCell: (hookData) => {
      const cell = hookData.cell
      const text = cell._verticalContent
      if (!text) return
      const { doc } = hookData

      doc.setFont(FONT_NAME)
      doc.setFontSize(VERTICAL_FONT_SIZE)

      const ptToMm = 0.3528
      const lineHeightMm = VERTICAL_FONT_SIZE * 1.2 * ptToMm
      const availHeight = cell.height - 3
      const lines = doc.splitTextToSize(text, availHeight)

      const totalBlockWidth = lines.length * lineHeightMm
      const firstLineX = cell.x + (cell.width - totalBlockWidth) / 2 + lineHeightMm / 2
      const baseY = cell.y + cell.height - 1.5

      lines.forEach((line, i) => {
        doc.text(line, firstLineX + i * lineHeightMm, baseY, {
          angle: 90,
          align: 'left',
        })
      })
    },
  }

  const baseTableOptions = (startY) => ({
    startY,
    margin: { left: 14, right: 14 },
    tableWidth: 'auto',
    styles: {
      font: FONT_NAME,
      fontSize: BODY_FONT_SIZE,
      cellPadding: 2,
      lineWidth: 0.1,
      lineColor: 200,
      halign: 'center',
      valign: 'middle',
      overflow: 'linebreak',
    },
    headStyles: {
      fillColor: [250, 250, 250],
      textColor: 20,
      fontStyle: 'bold',
      fontSize: HEAD_FONT_SIZE,
      halign: 'center',
      valign: 'middle',
    },
    theme: 'grid',
    ...verticalHeadHooks,
  })

  const drawStaffingTable = (doc, row, startY) => {
    const head = [
      [
        ...GROUPS.map(g => ({ content: g.label, colSpan: 3 })),
        { content: 'Стаж работы', colSpan: 4 },
      ],
      [
        ...GROUPS.flatMap(() => [v('По штату'), v('По списку'), v('Количество офицеров запаса')]),
        ...EXPERIENCE.map(e => v(e.label)),
      ],
    ]
    const body = [
      [
        ...GROUPS.flatMap(g => [fmt(row[g.staff]), fmt(row[g.list]), fmt(row[g.reserve])]),
        ...EXPERIENCE.map(e => fmt(row[e.field])),
      ],
    ]
    doc.autoTable({ ...baseTableOptions(startY), head, body })
  }

  const drawPedagogicalTable = (doc, row, startY) => {
    const head = [
      [
        { content: 'Количество педагогических работников', colSpan: 3 + POSITIONS.length },
        { content: 'Квалификация', colSpan: CATEGORIES.length },
        { content: 'Стаж работы', colSpan: EXPERIENCE.length },
      ],
      [
        v('По штату', { rowSpan: 2 }),
        v('По списку', { rowSpan: 2 }),
        v('Офицеров запаса', { rowSpan: 2 }),
        { content: 'из них:', colSpan: POSITIONS.length },
        ...CATEGORIES.map(c => v(c.label, { rowSpan: 2 })),
        ...EXPERIENCE.map(e => v(e.label, { rowSpan: 2 })),
      ],
      POSITIONS.map(p => v(p.label)),
    ]
    const body = [
      [
        fmt(row.totalPedStaff),
        fmt(row.totalPedList),
        fmt(row.reserveOfficersPedagogical),
        ...POSITIONS.map(p => fmt(row[p.field])),
        ...CATEGORIES.map(c => fmt(row[c.field])),
        ...EXPERIENCE.map(e => fmt(row[e.field])),
      ],
    ]
    doc.autoTable({ ...baseTableOptions(startY), head, body })
  }

  const drawAwardsTable = (doc, row, startY) => {
    const awards = getAwardsList(row)
    if (!awards.length) return false

    const totalCols = awards.length * AWARD_CATEGORIES.length
    const head = [
      awards.map(a => ({ content: a.typeName, colSpan: AWARD_CATEGORIES.length })),
      awards.flatMap(() => AWARD_CATEGORIES.map(c => v(c.label))),
    ]
    const sectionStyles = {
      halign: 'center',
      fontStyle: 'bold',
      fillColor: [240, 244, 255],
      textColor: [0, 112, 192],
    }
    const body = [
      [{ content: 'За отчетный учебный год', colSpan: totalCols, styles: sectionStyles }],
      awards.flatMap(a => AWARD_CATEGORIES.map(c => fmt(a.forYear?.[c.key]))),
      [{ content: 'Всего', colSpan: totalCols, styles: sectionStyles }],
      awards.flatMap(a => AWARD_CATEGORIES.map(c => fmt(a.cumulative?.[c.key]))),
    ]
    doc.autoTable({ ...baseTableOptions(startY), head, body })
    return true
  }

  const getPdfData = async () => {
    addFont(jsPDF.API)
    const doc = new jsPDF({ putOnlyUsedFonts: true, orientation, format: 'a4' })

    doc.setFont(FONT_NAME)

    const staffingRows = data?.staffing?.rows || []
    const pedById = byId(data?.pedagogical?.rows)
    const awardsById = byId(data?.awards?.rows)

    const academicYear = data?.staffing?.academicYear
      || data?.pedagogical?.academicYear
      || data?.awards?.academicYear
    const yearTitle = academicYear
      ? `в ${academicYear} учебном году`
      : 'за учебный год'

    let isFirstPage = true

    const openPage = () => {
      if (!isFirstPage) doc.addPage('a4', orientation)
      isFirstPage = false
    }

    staffingRows.forEach(org => {
      const orgId = org.organizationId
      const organizationName = org.organizationName
      const ped = pedById[orgId]
      const aw = awardsById[orgId]

      openPage()
      let y = drawPageHeader(doc, {
        tableNumber: 1,
        tableTitle: 'Сведения о работниках',
        organizationName,
        yearTitle,
      })
      drawStaffingTable(doc, org, y)

      if (ped) {
        openPage()
        y = drawPageHeader(doc, {
          tableNumber: 2,
          tableTitle: 'Сведения о педагогических работниках',
          organizationName,
          yearTitle,
        })
        drawPedagogicalTable(doc, ped, y)
      }

      if (aw && getAwardsList(aw).length) {
        openPage()
        y = drawPageHeader(doc, {
          tableNumber: 3,
          tableTitle: 'Сведения о награжденных работниках',
          organizationName,
          yearTitle,
        })
        drawAwardsTable(doc, aw, y)
      }
    })

    return doc
  }

  const toPdf = () => {
    getPdfData().then(doc => doc.save(`${fileTitle}.pdf`))
  }

  if (!visible) return null

  return (
    <div className={styles.buttonsBlock}>
      <Button theme='danger' className={'mb-2'} onClick={toPdf}>
        Скачать .pdf
      </Button>
    </div>
  )
}
